import React from "react";
import { Route, Routes } from "react-router-dom";
import { UserRoles } from "../../../constants/userRoles";
import { PrivateRoute } from "../../../keycloak";
import { ContractDetails } from "./ContractDetails/ContractDetails";
import { ContractEdit } from "./ContractEdit/ContractEdit";

export const ContractView = () => {
  return (
    <Routes>
      <Route path="details">
        <Route
          element={
            <PrivateRoute
              roles={{
                dcs_client: [UserRoles.CLIENT_UPDATE],
              }}
            />
          }
        >
          <Route path="edit" element={<ContractEdit />} />
        </Route>
        <Route path="" element={<ContractDetails />} />
      </Route>
    </Routes>
  );
};
